export class QualityControlRoad {
    id!: string
    job!: string
    streetAreaName!: string
    subContractorVendorId!: number | undefined
    supplier!: number | undefined
    testingAgencyVendorId!: number | undefined
    requiredMix!: string
    requiredCompaction!: string
    requiredThickness!: string
    minimumPavingTemp!: string
    minimumNumberTest!: string
    roadBaseDepth!: string
    roadBaseCompactionRequired!: string
    roadBaseTestingFrequency!: string
    createdOn!: Date
    modifiedOn!: Date
}
